import React, { Component } from 'react';
import Colors from '../constants/Colors';
import TournamentMatch from './TournamentMatch';
import SearchBar from './SearchBar';

export default class TournamentColumnView extends Component {

    state = {
        rounds: this.props.rounds,
    }

    componentDidMount() {

        this.setState({ rounds: this.props.rounds });
    }

    searchMatch(docs, text) {

        let result = [];

        result = docs.filter((doc) => {
    
            const court = doc['court'] ? doc['court'].toUpperCase() : ''.toUpperCase();

            let p1UserOne = doc['p1'] && doc['p1'][0] ? this.props.users.find(item => item.id === doc['p1'][0]) : '';
            let p1UserTwo = doc['p1'] && doc['p1'][1] ? this.props.users.find(item => item.id === doc['p1'][1]) : '';

            let p2UserOne = doc['p2'] && doc['p2'][0] ? this.props.users.find(item => item.id === doc['p2'][0]) : '';
            let p2UserTwo = doc['p2'] && doc['p2'][1] ? this.props.users.find(item => item.id === doc['p2'][1]) : '';
            
            const p1One = p1UserOne ? p1UserOne.name.toUpperCase() : '';
            const p1Two = p1UserTwo ? p1UserTwo.name.toUpperCase() : '';
            
            const p2One = p2UserOne ? p2UserOne.name.toUpperCase() : '';
            const p2Two = p2UserTwo ? p2UserTwo.name.toUpperCase() : '';

            const search = text.toString().toUpperCase();

            if (court.indexOf(search) > -1) {

                return true;
            }

            if (p1One.indexOf(search) > -1) {

                return true;
            }

            if (p1Two.indexOf(search) > -1) {

                return true;
            }

            if (p2One.indexOf(search) > -1) {

                return true;
            }

            if (p2Two.indexOf(search) > -1) {

                return true;
            }

            return false;
        });

        return result;
    }

    async handleMatchSearch(round, result) {

        let rounds = this.state.rounds;

        if (rounds[round]) {

            rounds[round].matches = [];

            await this.setState({ rounds: rounds });
        
            rounds[round].matches = result;
    
            await this.setState({ rounds: rounds });
        }
    }

    renderRounds() {

        return (
            <div style={{ display: 'flex', flexDirection: 'row', position: 'relative' }}>

                { 
                    this.state.rounds.map((round, key) => {

                        return (
                            <div style={{ marginRight: 25 }}>
                                <h4 style={{ position: 'absolute', top: 0, minWidth: 100, paddingLeft: 8 }}>{key === this.state.rounds.length - 1 ? 'Final' : `Rodada ${key + 1}`}</h4>
                                <div style={{ display: 'flex', padding: 8, boxShadow: Colors.boxShadow, borderRadius: 5, flexDirection: 'column', backgroundColor: 'white', marginTop: 80, marginRight: 0 }}>
                                    <SearchBar customSearch={(docs, text) => { return this.searchMatch(docs, text) }} placeholder={'Busque uma partida...'} iconStyle={{ fontSize: 22 }} style={{ height: 35, marginBottom: 8 }} docs={round.matches} search={'court'} onEmpty={(docs) => { this.handleMatchSearch(key, docs) }} onSearch={(result) => { this.handleMatchSearch(key, result) }} />
                                    {
                                        round.matches.map((match, matchKey) => {

                                            return <TournamentMatch view={'column'} {...this.props} round={key} match={match} index={matchKey}/>
                                            
                                        })
                                    }

                                    { !round.matches.length ? <p style={{ textAlign: 'center', color: 'grey' }}>{'Nenhum resultado encontrado.'}</p> : null }
                                </div>
                            </div>
                        )
                    })
                }

            </div>
        )
    }

    render() {
        return (
            <div style={{ padding: 25 }}>
                { this.state.rounds && this.state.rounds.length ? this.renderRounds() : null }
            </div>
        )
    }
}